import httpService from 'services/httpService.js';
import * as actionTypes from "./ActionTypes";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import planLimitMessage from "Utils/planLimitMessage";
import log from "loglevel";


export const labsLoaded = (data) => {
  return {
    type: actionTypes.LOAD_ALL_LABS,
    payload: data,
  };
};

export const examsLoaded = (data) => {
  return {
    type: actionTypes.LOAD_ALL_EXAMS,
    payload: data,
  };
};

export const studentsForExamLoaded = (data) => {
  return {
    type: actionTypes.LOAD_STUDENTS_FOR_EXAM,
    payload: data,
  };
};

export const labDelete = (data) => {
  return {
    type: actionTypes.DELETE_LAB,
    payload: data,
  };
};

export const labUpdate = (data) => {
  return {
    type: actionTypes.UPDATE_LAB,
    payload: data,
  };
};

export const bulkLabVisibilityUpdate = (data) => {
  return {
    type: actionTypes.BULK_UPDATE_LAB_VISIBILITY,
    payload: data,
  };
};

// Reorder labs - async thunk
export const reorderLabsRequest = (courseId, labs) => {
  return async (dispatch) => {
    try {
      const labIds = labs.map(lab => lab.id);
      await httpService.patch(
        `/lab/list/${courseId}`,
        { lab_ids: labIds }
      );
      dispatch(reorderLabsSuccess(labs));
      displayGlobalMessage("Labs reordered successfully", "success");
    } catch (error) {
      displayGlobalMessage("Failed to reorder labs", "error");
      throw error;
    }
  };
};

// Reorder labs - success action creator
export const reorderLabsSuccess = (labs) => {
  return {
    type: actionTypes.REORDER_LABS_SUCCESS,
    payload: labs,
  };
};

export const examStart = (data) => {
  return {
    type: actionTypes.START_EXAM,
    payload: data,
  };
};

export const examEnd = (data) => {
  return {
    type: actionTypes.END_EXAM,
    payload: data,
  };
};

export const examReset = (data) => {
  return {
    type: actionTypes.RESET_EXAM,
    payload: data,
  };
};

export const examVisibility = (data) => {
  return {
    type: actionTypes.VISIBILITY_EXAM,
    payload: data,
  }
}


export const labCreate = (data) => {
  return {
    type: actionTypes.CREATE_LAB,
    payload: data,
  };
};

export const activitiesLoaded = (data) => {
  return {
    type: actionTypes.LOAD_ALL_ACTIVITIES,
    payload: data,
  };
};

export const activityDelete = (labId, activityId) => {
  return {
    type: actionTypes.DELETE_ACTIVITY,
    payload: { labId, activityId },
  };
};

export const activityUpdate = (data) => {
  return {
    type: actionTypes.UPDATE_ACTIVITY,
    payload: data,
  };
};

export const activityCreate = (data) => {
  return {
    type: actionTypes.CREATE_ACTIVITY,
    payload: data,
  };
};

// Reorder activities - async thunk
export const reorderActivitiesRequest = (labId, activities) => {
  return async (dispatch) => {
    try {
      const activityData = activities.map(activity => ({
        id: activity.id,
        type: activity.typeOfActivity
      }));
      await httpService.patch(
        `/lab/activity/${labId}`,
        { activities: activityData }
      );
      dispatch(reorderActivitiesSuccess(labId, activities));
      displayGlobalMessage("Activities reordered successfully", "success");
    } catch (error) {
      displayGlobalMessage("Failed to reorder activities", "error");
      throw error;
    }
  };
};

// Reorder activities - success action creator
export const reorderActivitiesSuccess = (labId, activities) => {
  return {
    type: actionTypes.REORDER_ACTIVITIES_SUCCESS,
    payload: { labId, activities },
  };
};

// Load Labs (paginated, with server-side filtering and sorting)
export const loadLabsPaginated = (courseId, { page = 1, pageSize = 10, sort = '', tab = 'all', searchQuery = '' } = {}) => {
  return async (dispatch, getState) => {
    const state = getState()
    const mode = state?.userInfo?.mode
    const sortParam = sort ? `&sort=${sort}` : ''
    const tabParam = tab !== 'all' ? `&tab=${tab}` : ''
    const searchParam = searchQuery ? `&search_query=${encodeURIComponent(searchQuery)}` : ''
    const modeParam = mode ? `&mode=${mode}` : ''

    const response = await httpService.get(
      `/lab/list/${courseId}?page=${page}&page_size=${pageSize}${sortParam}${tabParam}${searchParam}${modeParam}`
    )
    dispatch({
      type: actionTypes.LOAD_LABS_PAGINATED,
      payload: response.data,
    })
    return response
  }
}

// Load Labs (all - used for reorder mode)
export const loadLabs = (courseId) => {
  return async (dispatch, getState) => {
    try {
      // log.log("Hello Axios", httpService.defaults);
      //Pagination implemented in the backend "all" in the URL returns all the entries
      //For getting specific page no (e.g. page no 10) use URL in the format "/lab/list/${courseId}?page=10"
      const state = getState();
      const mode = state?.userInfo?.mode;
      let params = {}
      if (mode) {
        params = { mode }
      }
      const response = await httpService.get(`/lab/list/all/${courseId}`, { params: params });
      log.log("Response for loadLabs ", response);
      dispatch(labsLoaded(response.data));
      return response;
    } catch (err) {
      log.log(err);
    }
  };
};

// Delete Lab
export const deleteLab = (courseId, labId) => {
  return async (dispatch) => {
    try {
      // log.log("Hello Axios", httpService.defaults);
      const response = await httpService.delete(`/lab/${labId}`);
      log.log(response);
      log.log(labId);
      displayGlobalMessage("Lab has been deleted Successfully!", "success");
      dispatch(labDelete(labId));
    } catch (err) {
      log.log(err);
      displayGlobalMessage("Error in deleting Lab!", "error");
    }
  };
};

// Create Lab
export const createLab = (courseId, formdata) => {
  return async (dispatch) => {
    try {
      // log.log("Hello Axios", formdata);
      const response = await httpService.post(`/lab/${courseId}`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        // Handle errors here so the friendly backend message reaches the user instead of the interceptor's generic "Something went wrong".
        skipErrorToast: true,
      });
      log.log("Response for Create Lab:", response);
      displayGlobalMessage("Lab has been created Successfully!", "success");
      dispatch(labCreate(response.data));
      return response;
    } catch (err) {
      // log.log('action err: ', err);
      // Skip toast if already handled by interceptor (V2 error reporting)
      if (err._errorReportHandled === true) {
        return;
      }
      // response code based error dialog
      let responseStatusCode = err.response?.status;
      if(responseStatusCode == 403) {
        displayGlobalMessage(planLimitMessage(err) || "Access Denied!", "error");
        return;
      }
      const backendMsg = err.response?.data?.error || err.response?.data?.errors;
      displayGlobalMessage(backendMsg || "Error creating lab", "error");
    }
  };
};

// Update Lab
export const updateLab = (courseId, formdata, labId) => {
  return async (dispatch) => {
    try {
      // log.log("Hello Axios", httpService.defaults);
      const response = await httpService.put(`/lab/${labId}`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        // Handle errors here so the friendly backend message reaches the user instead of the interceptor's generic "Something went wrong".
        skipErrorToast: true,
      });
      log.log("Response for Update Lab:", response);
      dispatch(labUpdate(response.data));
      displayGlobalMessage("Lab has been updated Successfully!", "success");
      return response;
    } catch (err) {
      log.log('Actions err: ', err);
      if (err._errorReportHandled === true) {
        return;
      }
      // response code based error dialog
      let responseStatusCode = err.response?.status;
      if(responseStatusCode == 403) {
        displayGlobalMessage(planLimitMessage(err) || "Access Denied!", "error");
        return;
      }
      const backendMsg = err.response?.data?.error || err.response?.data?.errors;
      displayGlobalMessage(backendMsg || "Error updating lab", "error");
    }
  };
};

// Bulk Update Lab Visibility
export const bulkUpdateLabVisibility = (courseId, labIds, isVisible) => {
  return async (dispatch, getState) => {
    try {
      // Optimistic update - update state immediately
      dispatch(bulkLabVisibilityUpdate({ labIds, isVisible }));

      // Make API call
      let formData = new FormData();
      formData.append("lab_ids", JSON.stringify(labIds));
      formData.append("is_lab_visible", isVisible);

      const response = await httpService.put(
        `/lab/list/${courseId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      log.log("Response for Bulk Update Lab Visibility:", response);

      // Note: Success message is now handled by the component for more accurate feedback
      // The component knows which labs were filtered and provides detailed messages

      // Re-fetch labs to ensure consistency
      await dispatch(loadLabs(courseId));

      return response;
    } catch (err) {
      log.log("Bulk visibility update error:", err);

      // Rollback optimistic update by re-fetching labs
      await dispatch(loadLabs(courseId));

      // Show error message
      let responseStatusCode = err.response?.status;
      if (responseStatusCode === 403) {
        displayGlobalMessage("Access Denied!", "error");
      } else if (err.response?.data?.error) {
        displayGlobalMessage(err.response.data.error, "error");
      } else {
        displayGlobalMessage("Error updating lab visibility!", "error");
      }
      throw err;
    }
  };
};

// Starting the Exam
export const startExam = (labId) => {
  return async (dispatch) => {
    try {
      const response = await httpService.put(`/exam/start/${labId}`, null, {
        params: {
          method: "startExam",
        },
      });
      log.log("Response for Start Exam:", response);
      dispatch(examStart(response.data));
      displayGlobalMessage("Exam has been started Successfully!", "success");
      return response;
    } catch (err) {
      log.log(err);
      const errorMessage = err.response?.data?.errors || err.response?.data?.error || "Error in starting Exam!";
      displayGlobalMessage(errorMessage, "error");
    }
  };
};

// End Exam
export const endExam = (labId, mode = 'hard') => {
  return async (dispatch) => {
    try {
      const response = await httpService.put(`/exam/end/${labId}`, { mode }, {
        params: {
          method: "endExam",
        },
      });
      log.log("Response for End Exam:", response);
      dispatch(examEnd(response.data));
      displayGlobalMessage("Exam has been ended Successfully!", "success");
      return response;
    } catch (err) {
      log.log(err);
      displayGlobalMessage("Error in ending Exam!", "error");
    }
  };
};

// Reset Exam
export const resetExam = (labId) => {
  return async (dispatch) => {
    try {
      const response = await httpService.put(`/exam/reset/${labId}`, null, {
        params: {
          method: "resetExam",
        },
      });
      log.log("Response for Reset Exam:", response);
      dispatch(examReset(response.data));
      displayGlobalMessage("Exam has been reset Successfully!", "success");
      return response;
    } catch (err) {
      log.log(err);
      displayGlobalMessage("Error in resetting Exam!", "error");
    }
  };
};

// handle Exam Visibility
// export const visibilityExam = (labId) => {
//   return async (dispatch) => {
//     try {
//       const url = `/exam/make_exam_visible/${labId}`;
//       // const formdata = new FormData();
//       // formdata.append("is_exam_visible", true);
//       const response = await httpService.put(url, null, {
//         params: {
//           method: "is_exam_visible",
//         },
//       });
//       log.log("Response for Exam Visibility:", response);
//       dispatch(visibilityExam(response.data));
//       displayGlobalMessage("Exam Visibility has been updated Successfully!", "success");
//       return response;
//     } catch (err) {
//       log.log(err);
//       displayGlobalMessage("Error in updating Exam Visibility!", "error");
//     }
//   };
// };


export const visibilityExam = (labId, isVisible) => {
  return async (dispatch) => {
    try {
      const url = `/exam/make_exam_visible/${labId}`;
      // Create a FormData object to hold the visibility status
      const formdata = new FormData();
      formdata.append("is_lab_visible", isVisible);

      // Send the PUT request with the FormData
      const response = await httpService.put(url, formdata, {
        params: {
          method: "is_exam_visible",
        },
      });

      log.log("Response for Exam Visibility:", response);

      // Dispatch the action with the response data
      dispatch(examVisibility(response.data));

      // Display success message
      displayGlobalMessage("Exam Visibility has been updated Successfully!", "success");

      return response;
    } catch (err) {
      log.error("Error in updating Exam Visibility:", err);
      displayGlobalMessage("Error in updating Exam Visibility!", "error");
    }
  };
};


// Create Activity
export const createActivity = (courseId, labId, activityType, formdata) => {
  return async (dispatch) => {
    try {
      log.log("Activity FormData", formdata);
      let url = "lab/activity/" + labId + "?type=" + activityType;
      const response = await httpService.post(url, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      log.log("Response", response);
      dispatch(activityCreate({ labId: labId, activity: response.data }));
      displayGlobalMessage("Activity has been added Successfully!", "success");
      return response;
    } catch (err) {
      log.log(err);
      displayGlobalMessage(planLimitMessage(err) || "Error in adding Activity!", "error");
    }
  };
};

// Update Activity
export const updateActivity = (activityId, activityType, formdata) => {
  log.log("update activity");
  return async (dispatch) => {
    try {
      let url = "lab/activity/" + activityId + "?type=" + activityType;

      const response = await httpService.put(url, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      log.log("Response for Update Lab:", response);
      dispatch(activityUpdate({ activity: response }));
      displayGlobalMessage(
        "Activity has been updated Successfully!",
        "success"
      );
      return response;
    } catch (err) {
      log.log(err);
      displayGlobalMessage("Error in updating Actvity!", "error");
    }
  };
};

// Delete Activity
export const deleteActivity = (activityId, activityType) => {
  return async (dispatch) => {
    try {
      // log.log("Hello Axios", httpService.defaults);
      let url = "lab/activity/" + activityId + "?type=" + activityType;

      const response = await httpService.delete(url);
      log.log(response);
      log.log("Deleted Activity:", activityId);
      dispatch(activityDelete(activityId));
      displayGlobalMessage(
        "Activity has been deleted Successfully!",
        "success"
      );
      return response;
    } catch (err) {
      log.log(err);
      displayGlobalMessage("Error in deleting Activity!", "error");
    }
  };
};

// Load Exams to Proctor
export const loadExams = (courseId) => {
  return async (dispatch) => {
    try {
      const response = await httpService.get(`/exam/list/${courseId}`);
      log.log("Response for loadExams ", response);
      dispatch(examsLoaded(response.data));
      return response;
    } catch (err) {
      log.log(err);
    }
  };
};

// load Students taking an exam
export const loadStudents = (examId) => {
  return async (dispatch) => {
    try {
      const response = await httpService.get(`/exam/${examId}/proctor`);
      log.log("Response for loadStudents ", response);
      dispatch(studentsForExamLoaded(response.data));
      return response;
    } catch (err) {
      log.log(err);
    }
  };
};
